import { useState } from "react";
import { Lock, Eye, EyeOff, Mail } from "lucide-react";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Toaster } from "../components/ui/sonner";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Preencha e-mail e senha");
      return;
    }
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (!result.ok) {
      toast.error(result.error || "Falha no login");
      setPassword("");
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-4">
      <div className="w-full max-w-md" data-testid="login-page">
        <div className="flex flex-col items-center mb-8">
          <img
            src="/contovia-logo.png"
            alt="Contovia"
            className="h-20 w-20 rounded-xl object-cover bg-white border border-slate-200 mb-4"
          />
          <h1 className="font-display text-2xl sm:text-3xl font-semibold text-[#0F2942]">
            Contovia
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            Gestão para Contabilidade
          </p>
        </div>

        <form
          onSubmit={submit}
          className="bg-white border border-slate-200 rounded-xl p-6 sm:p-8 space-y-5"
        >
          <div className="flex items-center gap-2 text-[#0F2942]">
            <Lock className="h-4 w-4" />
            <span className="text-sm font-semibold uppercase tracking-wider">
              Acesso restrito
            </span>
          </div>

          <div>
            <Label htmlFor="email">E-mail</Label>
            <div className="relative mt-1">
              <Mail className="h-4 w-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
              <Input
                id="email"
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@crismar.com"
                autoFocus
                autoComplete="email"
                className="pl-9"
              />
            </div>
          </div>

          <div>
            <Label htmlFor="pwd">Senha</Label>
            <div className="relative mt-1">
              <Input
                id="pwd"
                data-testid="login-password-input"
                type={showPwd ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Digite sua senha"
                autoComplete="current-password"
                className="pr-10"
              />
              <button
                type="button"
                onClick={() => setShowPwd((v) => !v)}
                data-testid="toggle-password-visibility"
                className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 p-1"
                aria-label={showPwd ? "Ocultar senha" : "Mostrar senha"}
              >
                {showPwd ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
              </button>
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="w-full bg-[#0F2942] hover:bg-[#173E63] text-white"
          >
            {loading ? "Entrando..." : "Entrar"}
          </Button>

          <p className="text-xs text-slate-400 text-center pt-2">
            Sessão criptografada com JWT. Após 5 tentativas incorretas o acesso é bloqueado por 15 minutos.
          </p>
        </form>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
}
